export const isVerified = (user) => !!user && (user.age_verified === true || user.role === "admin");
